import { apiClient } from './apiClient';

export const aiService = {
  models: () => apiClient.get('/api/ai/models'),
};

export default aiService;
